import React from "react";
import useVouchereListHook from "./voucherListHook";
import "./voucherList.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "./column";


const VoucherList = () => {
    const { VoucherListState } = useVouchereListHook();
    const handleGetRowId = (e) => {
        return e?.ipdid
      }
    return (
        <div className="voucher-list col-12 m-auto">
            <div className="datatable w-100">
                <DataGrid
                    checkboxSelection={false}
                    className="datagrid"
                    rows={VoucherListState && VoucherListState !== null ? VoucherListState : []}
                    columns={userColumns}
                    rowsPerPageOptions={[10]}
                    getRowId={handleGetRowId}
                    loading={VoucherListState?.length > 0  ? false : false}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={VoucherListState}
                    pagination
                    pageSize={10}
                    disableColumnMenu={true}
                />
            </div>

        </div>
    );
};

export default VoucherList;